import {ModuleComponent} from "../../js/module-component";

export class ModHeader extends ModuleComponent{
    ready(){
        super.ready();
    }
}